import React, { useState } from "react";
import PropTypes from "prop-types";

export default function Register({
  registration_needed,
  onChange,
  registration_info
}) {

  const [isChecked, setIsCecked] = useState(registration_needed);

  function handleOnCheck(e) {
    setIsCecked(!isChecked);
    onChange(e);
  }

  return (
    <div className="register">
      <div>
        <input className="li-item"
          type="checkbox"
          name="registration_needed"
          checked={isChecked}
          value={!isChecked}
          onChange={handleOnCheck}
        />
        <label> Anmälan krävs</label>
        </div>
      {isChecked && (
        <div className="register-field">
          Hur anmäler jag mig?
          <input
            type="text"
            className="cost-info"
            name="registration_info"
            value={registration_info || ""}
            maxLength="1000"
            onChange={onChange}
          />
        </div>
      )}
    </div>
  );
}

Register.propTypes = {
  registration_info: PropTypes.string,
  registration_needed: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired
};
